import { CSSProperties, FunctionComponent, PropsWithChildren } from "react";
import { connectModal, InjectedProps } from "redux-modal";
import { useDispatch } from "react-redux";
import { hide } from "redux-modal";
import Modal from "@components/modals/newModals/Modal";
import { MODALS_ENUM } from "@constants/Modals";
import { useIntl } from "react-intl";

export interface CommonModalPropsI extends PropsWithChildren<InjectedProps> {
  handleClose(): void;
  formatMessage: ReturnType<typeof useIntl>["formatMessage"];
}

export interface IModalParams {
  readonly asking?: boolean;
  readonly NWC?: boolean; // - not wrapper close
  readonly NC?: boolean; // - no closed
  readonly style?: CSSProperties;
  readonly hideIcon?: boolean;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function WithModal<T extends PropsWithChildren<InjectedProps>>(
  name: MODALS_ENUM,
  Component: FunctionComponent<T>,
  params?: IModalParams
) {
  function withModalComponent(props: T) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const dispatch = useDispatch();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { formatMessage } = useIntl();
    const handleClose = () => {
      const aprops = props as any;
      aprops.onClosing && aprops.onClosing();
      dispatch(hide(name));
    };
    return (
      <Modal params={params} handleClose={handleClose}>
        <Component
          formatMessage={formatMessage}
          handleClose={handleClose}
          {...props}
        />
      </Modal>
    );
  }

  return connectModal({
    name,
    getModalState: (state) => state.modals,
  })(withModalComponent);
}
